import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";

/**
 * Says the answer below was built from information that has since changed, and
 * offers to regenerate it. Rendered above the answer by every surface that shows
 * one; visibility comes from `useAnswerOutdated`.
 */
export function AnswerOutdatedBanner({
  onRegenerate,
}: {
  onRegenerate: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      className="mb-2 flex flex-wrap items-center gap-x-2 text-xs text-muted-foreground"
    >
      <span>{t("answerOutdated.message")}</span>
      <Button
        variant="link"
        size="sm"
        className="h-auto p-0 text-xs"
        onClick={onRegenerate}
      >
        {t("answerOutdated.regenerate")}
      </Button>
    </div>
  );
}
